import React from "react";
import { User, GraduationCap, Bot } from "lucide-react";
import Message from "types/Message";
import eloriaAvatar from "assets/eloria-avatar.jpg";

interface MessageAvatarProps {
  messageType: Message["type"];
  size?: "sm" | "md" | "lg";
}

export function MessageAvatar({
  messageType,
  size = "md",
}: MessageAvatarProps) {
  const sizes = {
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-12 h-12",
  };

  const iconSizes = {
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
  };

  const getAvatarContent = () => {
    switch (messageType) {
      case "user":
        return (
          <div
            className={`bg-green-100 rounded-full flex items-center justify-center ${sizes[size]}`}
          >
            <User
              className={`bg-green-100 text-green-600 ${iconSizes[size]}`}
            />
          </div>
        );
      case "assistant":
        return (
          <img
            src={eloriaAvatar}
            alt="Eloria"
            className={`${sizes[size]} rounded-full object-cover flex-shrink-0`}
          />
        );
      case "operator":
        return (
          <div
            className={`bg-slate-100 rounded-full flex items-center justify-center ${sizes[size]}`}
          >
            <User className={`text-slate-600 ${iconSizes[size]}`} />
          </div>
        );
      case "manager":
        return (
          <div
            className={`bg-gray-100 rounded-full flex items-center justify-center ${sizes[size]}`}
          >
            <GraduationCap className={`text-gray-600 ${iconSizes[size]}`} />
          </div>
        );
      case "manager-response":
        return (
          <div
            className={`bg-gray-100 rounded-full flex items-center justify-center ${sizes[size]}`}
          >
            <Bot className={`text-gray-600 ${iconSizes[size]}`} />
          </div>
        );
      case "deferred":
        return (
          <div
            className={`bg-amber-100 rounded-full flex items-center justify-center ${sizes[size]}`}
          >
            <Bot className={`text-amber-700 ${iconSizes[size]}`} />
          </div>
        );
      default:
        return (
          <div
            className={`bg-gray-200 rounded-full flex items-center justify-center ${sizes[size]}`}
          >
            <User className={`text-gray-500 ${iconSizes[size]}`} />
          </div>
        );
    }
  };

  return getAvatarContent();
}
